module.exports = __webpack_public_path__ + "static/media/jose.bcbd1276.png";